import { useEffect, useState } from 'react';
import { hrApi } from '@/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { StatCard } from '@/components/ui/StatCard';
import type { HrWorkforceAnalytics } from '@/types/hr';
import { showApiError } from '@/utils/apiError';
import { downloadBlob } from '@/utils/downloadBlob';
import { notify } from '@/core/toast/notify';
export function HrReportsPage() {
  const [analytics, setAnalytics] = useState<HrWorkforceAnalytics | null>(null);

  useEffect(() => {
    hrApi.workforceAnalytics().then(setAnalytics).catch((err) => showApiError(err, 'Failed to load analytics'));
  }, []);

  const exportReport = async (reportType: string, format: 'CSV' | 'PDF' | 'EXCEL') => {
    try {
      const blob = await hrApi.exportReport(reportType, format);
      const ext = format === 'EXCEL' ? 'xlsx' : format.toLowerCase();
      downloadBlob(blob, `${reportType.toLowerCase()}.${ext}`);
      notify.success(`${reportType} exported`);
    } catch (err) {
      showApiError(err, 'Export failed');
    }
  };

  const reportTypes = ['ATTENDANCE', 'LEAVE', 'PAYROLL', 'RECRUITMENT', 'TRAINING', 'PERFORMANCE', 'ATTRITION'];

  return (
    <div>
      <PageHeader
        title="HR Reports & Analytics"
        description="Headcount, attendance, leave, recruitment funnel, and training progress"
        breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'HR', to: '/hr' }, { label: 'Reports' }]}
      />
      <div className="mb-6 flex flex-wrap gap-2">
        {reportTypes.map((type) => (
          <div key={type} className="flex gap-1">
            <Button variant="secondary" onClick={() => exportReport(type, 'CSV')}>
              {type} CSV
            </Button>
            <Button variant="secondary" onClick={() => exportReport(type, 'PDF')}>
              PDF
            </Button>
          </div>
        ))}
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard title="Headcount" value={analytics?.headcount ?? '-'} />
        <StatCard title="Attendance %" value={analytics?.attendancePercent ?? '-'} />
        <StatCard title="Leave %" value={analytics?.leavePercent ?? '-'} />
        <StatCard title="Open positions" value={analytics?.openPositions ?? '-'} />
        <StatCard title="Candidates" value={analytics?.candidatesInPipeline ?? '-'} />
        <StatCard title="Training assignments" value={analytics?.trainingAssignments ?? '-'} />
        <StatCard title="Pending leaves" value={analytics?.pendingLeaves ?? '-'} />
        <StatCard title="Payroll runs" value={analytics?.payrollRuns ?? '-'} />
      </div>
    </div>
  );
}
